/*
 * Hover-to-open mega menu.
 *
 * Dawn opens its header <details> panels on click. The reference brand opens
 * them on hover, which is what reads as "professional" on a desktop storefront.
 * This adds hover intent on top of Dawn's markup without replacing its click
 * and keyboard behaviour — those still work, and this is switched off entirely
 * on touch and narrow screens, where hover has no meaning.
 */
(function () {
  'use strict';

  var OPEN_DELAY = 90; // ms of hover before opening — avoids firing on a pass-through
  var CLOSE_DELAY = 220; // ms of grace when travelling from the item to the panel

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var isDesktop = window.matchMedia('(min-width: 990px)');

  function enabled() {
    return canHover.matches && isDesktop.matches;
  }

  function init() {
    var nav = document.querySelector('.header__inline-menu');
    if (!nav) return;

    var panels = Array.prototype.slice.call(nav.querySelectorAll('details'));
    if (!panels.length) return;

    var openTimer = null;
    var closeTimer = null;

    function closeAll(except) {
      panels.forEach(function (d) {
        if (d !== except && d.open) {
          d.open = false;
          var summary = d.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }
      });
    }

    function open(details) {
      if (details.open) return;
      closeAll(details);
      details.open = true;
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    }

    panels.forEach(function (details) {
      details.addEventListener('mouseenter', function () {
        if (!enabled()) return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function () {
          open(details);
        }, OPEN_DELAY);
      });

      details.addEventListener('mouseleave', function () {
        if (!enabled()) return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () {
          closeAll(null);
        }, CLOSE_DELAY);
      });
    });

    // Leaving the header altogether closes everything straight away.
    var header = nav.closest('.header-wrapper') || nav;
    header.addEventListener('mouseleave', function () {
      if (!enabled()) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () {
        closeAll(null);
      }, CLOSE_DELAY);
    });

    // Escape closes, matching Dawn's own keyboard handling.
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll(null);
    });

    // If hover stops being available (rotated tablet, resized window), leave
    // nothing stuck open.
    [canHover, isDesktop].forEach(function (mq) {
      var onChange = function () {
        if (!enabled()) closeAll(null);
      };
      if (mq.addEventListener) mq.addEventListener('change', onChange);
      else if (mq.addListener) mq.addListener(onChange);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
